import React from 'react';
import { observer } from 'mobx-react-lite';
import { SuccessAlert } from '../success-alert';
import { ErrorAlert } from '../error-alert';
import { WarningAlert } from '../warning-alert';
import { useRootStore } from '../../../../providers/root-store-provider';
import { AlertPlacementEnum } from '../../../../models/enums/alert-placement-enum';

interface AlertsPropsInterface {
    email?: string;
}

export const ModalAlerts: React.FC<AlertsPropsInterface> = observer(({ email }: AlertsPropsInterface) => {
    const { alertStore } = useRootStore();

    if (alertStore.alertPlacement !== AlertPlacementEnum.Modal) {
        return null;
    }

    return (
        <div className="flex flex-col items-center pt-small empty:hidden md:pt-[3.2rem]">
            <SuccessAlert />
            <ErrorAlert email={email} />
            <WarningAlert />
        </div>
    );
});
